export const apiWithNoUserTokenNeededList: string[] = [
  'Login',
  'Signup',
  'RenewPasswordLink',
  'UpdatePassword',
  'VerifiyIdentity',
  'GetResult'
];

export const apiWithNoFloatingMessageList: string[] = [
   ...apiWithNoUserTokenNeededList,
   'EprotectInformation',
   'GetTransactionFee',
   'CreditCardDeposit',
];

export const GUEST = 'Guest';
export const GUEST_USER = 'Guest User';

export const PAGES_WITH_401_STATUS_CODE_BUT_SKIP_WAGER_REDIRECT: string[] = [
  '/login',
  '/signup',
  '/forgot-password',
];

export const INACTIVE = 'Inactive';
